import { Transform, Type } from 'class-transformer';
import { List } from '@/models/list';
import { City } from '@/models/city';
import cuid from 'cuid';

export class Cities extends List {
  @Transform(({ value }) => {
    return value.map((name: string) => {
      return { id: cuid(), name };
    });
  })
  results!: City[];
}
